import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'why_choose_run_baby_run'

export default function WhyChooseRunBabyRunPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const reason = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What was the reason for choosing RunFusion?',
      answer_key: reason.toLowerCase(),
      answer: reason,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.whyChooseRunBabyRun.heading')}
      buttons={[
        {
          text: t('pages.onboarding.whyChooseRunBabyRun.options.getFit.title'),
          subtext: t(
            'pages.onboarding.whyChooseRunBabyRun.options.getFit.description',
          ),
          value: 'overall_health_and_wellness',
        },
        {
          text: t(
            'pages.onboarding.whyChooseRunBabyRun.options.loseWeight.title',
          ),
          subtext: t(
            'pages.onboarding.whyChooseRunBabyRun.options.loseWeight.description',
          ),
          value: 'achieving_a_personal_best_time',
        },
        {
          text: t(
            'pages.onboarding.whyChooseRunBabyRun.options.stayHealthy.title',
          ),
          subtext: t(
            'pages.onboarding.whyChooseRunBabyRun.options.stayHealthy.description',
          ),
          value: 'monitoring_my_training',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
